import ShareLocationOutlinedIcon from '@mui/icons-material/ShareLocationOutlined';
const icons = { ShareLocationOutlinedIcon };

// ==============================|| MENU ITEMS - FLEET REALTIME TRACKING ||============================== //

const fleetRealtimeTracking = {
  id: 'fleetRealtimeTracking',
  type: 'group',
  children: [
    {
      id: 'fleetRealtimeTracking',
      title: 'Fleet Realtime Tracking',
      type: 'item',
      url: '/maps-monitoring',
      icon: icons.ShareLocationOutlinedIcon
    }
  ]
};

export default fleetRealtimeTracking;
